/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-extra-boolean-cast */
import { CloseOutlined } from '@ant-design/icons'
import { Button, Form, notification, Space, Spin, Tabs } from 'antd'
import dayjs from 'dayjs'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { useGeneral, useHandleTicketModal } from '@contexts'
import { useConfigurationProperties } from '@hooks'
import { CommonTicketForm, DeliveryNote, TripTypeEnum } from '@types'
import { CutoffTimeUtils, DeliveryNoteUtils } from '@utils'

import { FlexRow, StyledModal } from '../../../components/StyledComponents'
import AddTicketFormSupplier from './AddTicketFormSupplier'

const { TICKET, PURCHASES } = QUERY_KEYS

const today = dayjs()
const tomorrow = today.clone()
tomorrow.add(1, 'day').startOf('d')

type TabValue = '1'

type Props = {
  onOk: (
    id: number | undefined,
    form: CommonTicketForm,
    resetForm: () => void,
    dates: Date[] | undefined,
    toApprove?: boolean | undefined,
  ) => void
  title: string
  isLoading: boolean
  onClose: (reset?: () => void) => void
  open?: boolean
}

const AddTicketModalSupplier: React.FC<Props> = ({ onClose, title, onOk, isLoading, open }) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { setTicketToEdit, setIsTicketModalOpen } = useHandleTicketModal()
  const { assignmentTickets, maxAllowedDaysForSupplierRequest, cutoffTimeHour } =
    useConfigurationProperties()
  const [form] = Form.useForm()
  const { setFormInstance } = useGeneral()
  const [formNotes] = Form.useForm()

  const [editable, setEditable] = useState<boolean>()
  const [isWarning, setIsWarning] = useState<boolean>()
  const [dates, setDates] = useState<Date[]>()
  const [primaryButtonIsDisabled, setPrimaryButtonIsDisabled] = useState<boolean>()
  const [activeTab, setActiveTab] = useState<TabValue>()
  const [noteContent, setNoteContent] = useState<string>()
  const cutoffTime =
    typeof cutoffTimeHour === 'number' && !Number.isNaN(cutoffTimeHour)
      ? `${String(cutoffTimeHour).padStart(2, '0')}:00`
      : CutoffTimeUtils.getCutoffTime()

  const handlePrimaryButtonDisabling = (value: boolean) => {
    setPrimaryButtonIsDisabled(!!value)
  }

  const resetModal = useCallback(() => {
    setTicketToEdit(0)
    setIsTicketModalOpen(false)
    queryClient.removeQueries([TICKET, PURCHASES])
    notification.destroy('validationError')
    setEditable(undefined)
    setIsWarning(undefined)
    setDates(undefined)
    setPrimaryButtonIsDisabled(undefined)
    setActiveTab(undefined)
    setNoteContent(undefined)
  }, [])

  const handleCloseModal = () => {
    onClose()
  }

  const handleAfterModalClose = () => {
    setDates(undefined)
  }

  const proceed = useCallback(() => {
    if (dates?.length === undefined) {
      setIsWarning(true)
    }
    form.setFieldsValue({ datesInput: dates?.length ? true : undefined })
    form
      .validateFields()
      .then(values => {
        const isTripCfr = values.tripType === TripTypeEnum.CFR
        if (!isTripCfr) {
          const hasInvalidDate = dates?.some(date =>
            CutoffTimeUtils.isDateBefore24HoursThreshold(date, cutoffTime),
          )
          if (hasInvalidDate) {
            notification.error({
              message: 'No se pueden solicitar viajes con menos de 24 horas de anticipación.',
              key: 'validationError24h',
            })
            return
          }
        }

        const deliveryNoteNumber = DeliveryNoteUtils.normalizeValue(values.number)
        const deliveryNote: DeliveryNote | undefined = deliveryNoteNumber
          ? {
              number: deliveryNoteNumber,
              ...(values.observation ? { observation: values.observation } : {}),
            }
          : undefined

        onOk(
          undefined,
          {
            ...(deliveryNote && { deliveryNote }),
            count: values.count,
            depotId: values.depotId,
            materialId: values.materialId,
            equipmentId: values.equipmentId,
            destinationId: values.destinationId,
            carrierId: values.carrierId,
            note: values.comments ? { description: values.comments } : undefined,
            documentNumberId: values.documentNumberId ?? undefined,
            type: assignmentTickets ? 'automatic' : 'manual',
            declinedLoad: values.declinedLoad,
            declinedLoadType: values.declinedLoadType,
            tripType: values.tripType,
            ticketSap:
              typeof values.ticketSap === 'string' && /^\d+$/.test(values.ticketSap)
                ? values.ticketSap
                : null,
          },
          handleCloseModal,
          dates,
          undefined,
        )
      })
      .catch(err => {
        console.log(err)
        notification.destroy('validationError')
        notification.error({
          message: t('globals.validation_error'),
          key: 'validationError',
        })
      })
  }, [dates, assignmentTickets])

  useEffect(() => {
    if (!open) {
      resetModal()
    } else {
      handlePrimaryButtonDisabling(false)
    }
  }, [open])

  useEffect(() => {
    if (primaryButtonIsDisabled === undefined) {
      setActiveTab(undefined)
    } else {
      setActiveTab('1')
    }
  }, [primaryButtonIsDisabled])

  useEffect(() => {
    if (!noteContent) {
      formNotes.setFieldsValue({ note: undefined })
    }
  }, [noteContent])

  useEffect(() => {
    if (form) {
      setFormInstance(form)
    }
    return () => {
      setFormInstance(undefined)
    }
  }, [form])

  return open ? (
    <StyledModal
      key="new-ticket"
      afterClose={handleAfterModalClose}
      destroyOnClose
      keyboard
      maskClosable
      className="create-modal supplier-modal"
      open={open}
      onCancel={handleCloseModal}
      title={<Space className="ticket-modal-header-tools">{title}</Space>}
      closeIcon={<CloseOutlined />}
      cancelText={t('suppliers_router.new_ticket_modal.cancelText')}
      footer={[
        <Button key="cancelar" onClick={handleCloseModal} target="closeModalButton">
          {t('suppliers_router.new_ticket_modal.cancelText')}
        </Button>,
        <Button
          type="primary"
          key="ok"
          onClick={proceed}
          disabled={!activeTab || primaryButtonIsDisabled}
        >
          {t('suppliers_router.new_ticket_modal.okText')}
        </Button>,
      ]}
    >
      {!!activeTab ? (
        <Tabs
          activeKey={activeTab}
          onTabClick={activeKey => {
            setActiveTab(activeKey as TabValue)
          }}
          items={[
            {
              label: t('ticket_modal.tab_info'),
              children: (
                <Spin className="ticket-modal-spinner" size="large" spinning={isLoading}>
                  <AddTicketFormSupplier
                    handlePrimaryButtonDisabling={handlePrimaryButtonDisabling}
                    editable={editable}
                    setEditable={setEditable}
                    dates={dates}
                    setDates={setDates}
                    isWarning={isWarning}
                    setIsWarning={setIsWarning}
                    form={form}
                    maxAllowedDaysForSupplierRequest={maxAllowedDaysForSupplierRequest}
                    cutoffTime={cutoffTime}
                  />
                </Spin>
              ),
              key: '1',
            },
          ]}
        />
      ) : (
        <FlexRow className="ticket-modal-spin-container">
          <Spin className="ticket-modal-spinner" size="large" />
        </FlexRow>
      )}
    </StyledModal>
  ) : null
}
export { AddTicketModalSupplier }
